import Icon from '@ant-design/icons';
import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import React from 'react';

type IconComponent = {
  [key: string]: React.ComponentType<React.SVGProps<SVGSVGElement>>;
};

export const Icons: IconComponent = {
  Company: () => (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7803 7.03032C19.6397 7.17097 19.4489 7.24999 19.25 7.24999H18.5V17H20V18.5H2V17H3.5V7.24999H2.75C2.55109 7.24999 2.36032 7.17097 2.21967 7.03032C2.07902 6.88966 2 6.6989 2 6.49999V4.24999C2.00007 4.09585 2.04762 3.94548 2.13619 3.81933C2.22476 3.69319 2.35005 3.59739 2.495 3.54499L10.745 0.544986C10.9098 0.485412 11.0902 0.485412 11.255 0.544986L19.505 3.54499C19.65 3.59739 19.7752 3.69319 19.8638 3.81933C19.9524 3.94548 19.9999 4.09585 20 4.24999V6.49999C20 6.6989 19.921 6.88966 19.7803 7.03032ZM11 2.04499L3.5 4.77499V5.74999H18.5V4.77499L11 2.04499ZM9.5 7.24999V17H12.5V7.24999H9.5ZM8 7.24999H5V17H8V7.24999ZM14 17H17V7.24999H14V17ZM0.5 21.5V20H21.5V21.5H0.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  CreateUser: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 3C9.74168 3 10.4667 3.21993 11.0834 3.63199C11.7001 4.04404 12.1807 4.62971 12.4646 5.31494C12.7484 6.00016 12.8226 6.75416 12.6779 7.48159C12.5333 8.20902 12.1761 8.8772 11.6517 9.40165C11.1272 9.9261 10.459 10.2833 9.73159 10.4279C9.00416 10.5726 8.25016 10.4984 7.56494 10.2145C6.87972 9.93072 6.29405 9.45007 5.88199 8.83339C5.46994 8.2167 5.25 7.49168 5.25 6.75C5.25 5.75544 5.64509 4.80161 6.34835 4.09835C7.05161 3.39509 8.00544 3 9 3ZM9 1.5C7.96165 1.5 6.94662 1.80791 6.08326 2.38478C5.2199 2.96166 4.54699 3.7816 4.14963 4.74091C3.75227 5.70022 3.64831 6.75582 3.85088 7.77422C4.05345 8.79262 4.55347 9.72808 5.28769 10.4623C6.02192 11.1965 6.95738 11.6966 7.97578 11.8991C8.99418 12.1017 10.0498 11.9977 11.0091 11.6004C11.9684 11.203 12.7883 10.5301 13.3652 9.66674C13.9421 8.80339 14.25 7.78835 14.25 6.75C14.25 5.35761 13.6969 4.02226 12.7123 3.03769C11.7277 2.05312 10.3924 1.5 9 1.5ZM24 10.5H21V7.5H19.5V10.5H16.5V12H19.5V15H21V12H24V10.5ZM15 22.5H16.5V18.75C16.5 17.3576 15.9469 16.0223 14.9623 15.0377C13.9777 14.0531 12.6424 13.5 11.25 13.5H6.75C5.35761 13.5 4.02226 14.0531 3.03769 15.0377C2.05312 16.0223 1.5 17.3576 1.5 18.75V22.5H3V18.75C3 17.7554 3.39509 16.8016 4.09835 16.0983C4.80161 15.3951 5.75544 15 6.75 15H11.25C12.2446 15 13.1984 15.3951 13.9017 16.0983C14.6049 16.8016 15 17.7554 15 18.75V22.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  AddUser: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0834 3.63199C13.4667 3.21993 12.7417 3 12 3C11.0054 3 10.0516 3.39509 9.34835 4.09835C8.64509 4.80161 8.25 5.75544 8.25 6.75C8.25 7.49168 8.46994 8.2167 8.88199 8.83339C9.29405 9.45007 9.87972 9.93072 10.5649 10.2145C11.2502 10.4984 12.0042 10.5726 12.7316 10.4279C13.459 10.2833 14.1272 9.9261 14.6517 9.40165C15.1761 8.8772 15.5333 8.20902 15.6779 7.48159C15.8226 6.75416 15.7484 6.00016 15.4646 5.31494C15.1807 4.62971 14.7001 4.04404 14.0834 3.63199ZM9.08326 2.38478C9.94662 1.80791 10.9617 1.5 12 1.5C13.3924 1.5 14.7277 2.05312 15.7123 3.03769C16.6969 4.02226 17.25 5.35761 17.25 6.75C17.25 7.78835 16.9421 8.80339 16.3652 9.66674C15.7883 10.5301 14.9684 11.203 14.0091 11.6004C13.0498 11.9977 11.9942 12.1017 10.9758 11.8991C9.95738 11.6966 9.02192 11.1965 8.28769 10.4623C7.55347 9.72808 7.05345 8.79262 6.85088 7.77422C6.64831 6.75582 6.75227 5.70022 7.14963 4.74091C7.54699 3.7816 8.2199 2.96166 9.08326 2.38478ZM18 22.5H19.5V18.75C19.5 17.3576 18.9469 16.0223 17.9623 15.0377C16.9777 14.0531 15.6424 13.5 14.25 13.5H9.75C8.35761 13.5 7.02226 14.0531 6.03769 15.0377C5.05312 16.0223 4.5 17.3576 4.5 18.75V22.5H6V18.75C6 17.7554 6.39509 16.8016 7.09835 16.0983C7.80161 15.3951 8.75544 15 9.75 15H14.25C14.7425 15 15.2301 15.097 15.6851 15.2855C16.14 15.4739 16.5534 15.7501 16.9017 16.0983C17.2499 16.4466 17.5261 16.86 17.7145 17.3149C17.903 17.7699 18 18.2575 18 18.75V22.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  AddUserPlus: () => (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.5 1.5C7.11807 1.5 7.72226 1.68328 8.23616 2.02666C8.75006 2.37004 9.1506 2.8581 9.38713 3.42911C9.62365 4.00013 9.68553 4.62847 9.56496 5.23466C9.44438 5.84085 9.14675 6.39767 8.70971 6.83471C8.27267 7.27175 7.71585 7.56938 7.10966 7.68995C6.50347 7.81053 5.87514 7.74865 5.30412 7.51212C4.7331 7.2756 4.24504 6.87506 3.90166 6.36116C3.55828 5.84725 3.375 5.24307 3.375 4.625C3.375 3.7962 3.70424 3.00134 4.29029 2.41529C4.87634 1.82924 5.6712 1.5 6.5 1.5ZM6.5 0.25C5.63471 0.25 4.78885 0.506589 4.06938 0.98732C3.34992 1.46805 2.78916 2.15133 2.45803 2.95076C2.1269 3.75019 2.04026 4.62985 2.20907 5.47852C2.37788 6.32719 2.79456 7.10674 3.40641 7.71859C4.01826 8.33045 4.79782 8.74712 5.64648 8.91594C6.49515 9.08475 7.37481 8.99811 8.17424 8.66697C8.97367 8.33584 9.65695 7.77508 10.1377 7.05562C10.6184 6.33615 10.875 5.49029 10.875 4.625C10.875 3.46468 10.4141 2.35188 9.59359 1.53141C8.77312 0.710936 7.66032 0.25 6.5 0.25ZM19 7.75H16.5V5.25H15.25V7.75H12.75V9H15.25V11.5H16.5V9H19V7.75ZM11.5 17.75H12.75V14.625C12.75 13.4647 12.2891 12.3519 11.4686 11.5314C10.6481 10.7109 9.53532 10.25 8.375 10.25H4.625C3.46468 10.25 2.35188 10.7109 1.53141 11.5314C0.710936 12.3519 0.25 13.4647 0.25 14.625V17.75H1.5V14.625C1.5 13.7962 1.82924 13.0013 2.41529 12.4153C3.00134 11.8292 3.7962 11.5 4.625 11.5H8.375C9.2038 11.5 9.99866 11.8292 10.5847 12.4153C11.1708 13.0013 11.5 13.7962 11.5 14.625V17.75Z"
        fill="currentColor"
      />
    </svg>
  ),
  AddUserGroup: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 6.75C5.40666 6.75 4.82664 6.57405 4.33329 6.24441C3.83994 5.91477 3.45543 5.44623 3.22836 4.89805C3.0013 4.34987 2.94189 3.74667 3.05765 3.16473C3.1734 2.58279 3.45912 2.04824 3.87868 1.62868C4.29824 1.20912 4.83279 0.923401 5.41473 0.807646C5.99667 0.69189 6.59987 0.7513 7.14805 0.978363C7.69623 1.20543 8.16477 1.58994 8.49441 2.08329C8.82405 2.57664 9 3.15666 9 3.75C9 4.54565 8.68393 5.30871 8.12132 5.87132C7.55871 6.43393 6.79565 6.75 6 6.75ZM6 2.25C5.70333 2.25 5.41332 2.33797 5.16665 2.5028C4.91997 2.66762 4.72771 2.90189 4.61418 3.17598C4.50065 3.45007 4.47095 3.75167 4.52882 4.04264C4.5867 4.33361 4.72956 4.60088 4.93934 4.81066C5.14912 5.02044 5.41639 5.1633 5.70737 5.22118C5.99834 5.27906 6.29994 5.24935 6.57403 5.13582C6.84812 5.02229 7.08238 4.83003 7.24721 4.58336C7.41203 4.33668 7.5 4.04667 7.5 3.75C7.5 3.35218 7.34197 2.97065 7.06066 2.68934C6.77936 2.40804 6.39783 2.25 6 2.25ZM18 6.75C17.4067 6.75 16.8266 6.57405 16.3333 6.24441C15.8399 5.91477 15.4554 5.44623 15.2284 4.89805C15.0013 4.34987 14.9419 3.74667 15.0576 3.16473C15.1734 2.58279 15.4591 2.04824 15.8787 1.62868C16.2982 1.20912 16.8328 0.923401 17.4147 0.807646C17.9967 0.69189 18.5999 0.7513 19.1481 0.978363C19.6962 1.20543 20.1648 1.58994 20.4944 2.08329C20.8241 2.57664 21 3.15666 21 3.75C21 4.54565 20.6839 5.30871 20.1213 5.87132C19.5587 6.43393 18.7957 6.75 18 6.75ZM18 2.25C17.7033 2.25 17.4133 2.33797 17.1666 2.5028C16.92 2.66762 16.7277 2.90189 16.6142 3.17598C16.5007 3.45007 16.4709 3.75167 16.5288 4.04264C16.5867 4.33361 16.7296 4.60088 16.9393 4.81066C17.1491 5.02044 17.4164 5.1633 17.7074 5.22118C17.9983 5.27906 18.2999 5.24935 18.574 5.13582C18.8481 5.02229 19.0824 4.83003 19.2472 4.58336C19.412 4.33668 19.5 4.04667 19.5 3.75C19.5 3.35218 19.342 2.97065 19.0607 2.68934C18.7794 2.40804 18.3978 2.25 18 2.25ZM16.5 22.5H19.5C19.8978 22.5 20.2794 22.342 20.5607 22.0607C20.842 21.7794 21 21.3978 21 21V15.75C21.3978 15.75 21.7794 15.592 22.0607 15.3107C22.342 15.0294 22.5 14.6478 22.5 14.25V9.75C22.5 9.15326 22.2629 8.58097 21.841 8.15901C21.419 7.73705 20.8467 7.5 20.25 7.5H14.565L12 12L9.435 7.5H3.75C3.15326 7.5 2.58097 7.73705 2.15901 8.15901C1.73705 8.58097 1.5 9.15326 1.5 9.75V14.25C1.5 14.6478 1.65804 15.0294 1.93934 15.3107C2.22064 15.592 2.60218 15.75 3 15.75V21C3 21.3978 3.15804 21.7794 3.43934 22.0607C3.72064 22.342 4.10218 22.5 4.5 22.5H7.5C7.89782 22.5 8.27936 22.342 8.56066 22.0607C8.84196 21.7794 9 21.3978 9 21V15.75H7.5V21H4.5V14.25H3V9.75C3 9.55109 3.07902 9.36032 3.21967 9.21967C3.36032 9.07902 3.55109 9 3.75 9H8.565L12 15L15.435 9H20.25C20.4489 9 20.6397 9.07902 20.7803 9.21967C20.921 9.36032 21 9.55109 21 9.75V14.25H19.5V21H16.5V15.75H15V21C15 21.3978 15.158 21.7794 15.4393 22.0607C15.7206 22.342 16.1022 22.5 16.5 22.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  Home: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4592 1.66037C12.3261 1.55648 12.1621 1.50006 11.9932 1.50006C11.8243 1.50006 11.6603 1.55648 11.5272 1.66037L0.75 10.0646L1.68203 11.2433L3 10.2157V19.5C3.00081 19.8976 3.15911 20.2787 3.44024 20.5598C3.72137 20.8409 4.10242 20.9992 4.5 21H19.5C19.8976 20.9993 20.2787 20.841 20.5599 20.5599C20.841 20.2787 20.9993 19.8976 21 19.5V10.2225L22.318 11.25L23.25 10.0712L12.4592 1.66037ZM13.5 19.5H10.5V13.5H13.5V19.5ZM15 19.5V13.5C14.9995 13.1023 14.8414 12.7211 14.5602 12.4399C14.279 12.1587 13.8977 12.0005 13.5 12H10.5C10.1023 12.0004 9.721 12.1586 9.43978 12.4398C9.15856 12.721 9.0004 13.1023 9 13.5V19.5H4.5V9.04614L12 3.20364L19.5 9.05402V19.5H15Z"
        fill="currentColor"
      />
    </svg>
  ),
  Rocket: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4725 22.4474C12.5608 22.4823 12.655 22.5002 12.75 22.4999C12.9191 22.4989 13.083 22.4408 13.215 22.3349L16.965 19.3349C17.0533 19.2651 17.1249 19.1762 17.1742 19.0749C17.2235 18.9737 17.2494 18.8626 17.25 18.7499V13.0574L20.085 10.2299C20.8536 9.46555 21.4629 8.55618 21.8775 7.55455C22.292 6.55292 22.5036 5.47895 22.5 4.39492V2.99992C22.5 2.6021 22.3419 2.22057 22.0606 1.93926C21.7793 1.65796 21.3978 1.49992 21 1.49992H19.605C18.5209 1.49627 17.447 1.70786 16.4453 2.12242C15.4437 2.53697 14.5343 3.14625 13.77 3.91492L10.9425 6.74992H5.24996C5.13669 6.75134 5.02521 6.77839 4.92389 6.82905C4.82257 6.87971 4.73405 6.95266 4.66496 7.04243L1.66496 10.7924C1.58125 10.8962 1.5267 11.0203 1.50692 11.1522C1.48715 11.284 1.50287 11.4187 1.55246 11.5424C1.60144 11.6653 1.68205 11.773 1.7861 11.8547C1.89016 11.9364 2.01396 11.9891 2.14496 12.0074L7.39496 12.7574L7.60496 11.2574L3.65246 10.6949L5.60996 8.24993H11.25C11.3487 8.2505 11.4465 8.23158 11.5379 8.19425C11.6293 8.15693 11.7124 8.10194 11.7825 8.03242L14.835 4.97992C15.4597 4.35095 16.2029 3.85209 17.0217 3.51223C17.8404 3.17237 18.7185 2.99824 19.605 2.99992H21V4.39492C21.0016 5.28142 20.8275 6.15945 20.4877 6.97821C20.1478 7.79698 19.6489 8.54021 19.02 9.16493L15.9675 12.2174C15.8979 12.2875 15.843 12.3706 15.8056 12.462C15.7683 12.5534 15.7494 12.6512 15.75 12.7499V18.3899L13.32 20.3474L12.7575 16.3949L11.2575 16.6049L12.0075 21.8549C12.0258 21.9859 12.0785 22.1097 12.1602 22.2138C12.2419 22.3178 12.3496 22.3984 12.4725 22.4474ZM5.46606 17.469L11.4641 11.4709L12.5248 12.5316L6.52672 18.5296L5.46606 17.469Z"
        fill="currentColor"
      />
    </svg>
  ),
  RoadMap: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 7.5H12C12.3977 7.49954 12.779 7.34136 13.0602 7.06016C13.3414 6.77895 13.4995 6.39768 13.5 6V3C13.4995 2.60232 13.3414 2.22105 13.0602 1.93984C12.779 1.65864 12.3977 1.50046 12 1.5H3C2.60232 1.50046 2.22105 1.65864 1.93984 1.93984C1.65864 2.22105 1.50046 2.60232 1.5 3V6C1.50046 6.39768 1.65864 6.77895 1.93984 7.06016C2.22105 7.34136 2.60232 7.49954 3 7.5ZM3 6V3H12V6H3ZM21 15H9C8.60232 14.9995 8.22105 14.8414 7.93984 14.5602C7.65864 14.279 7.50046 13.8977 7.5 13.5V10.5C7.50046 10.1023 7.65864 9.72105 7.93984 9.43984C8.22105 9.15864 8.60232 9.00046 9 9H21C21.3977 9.00046 21.7789 9.15864 22.0602 9.43984C22.3414 9.72105 22.4995 10.1023 22.5 10.5V13.5C22.4995 13.8977 22.3414 14.279 22.0602 14.5602C21.7789 14.8414 21.3977 14.9995 21 15ZM9 10.5V13.5H21V10.5H9ZM9 22.5H3C2.60232 22.4995 2.22105 22.3414 1.93984 22.0602C1.65864 21.7789 1.50046 21.3977 1.5 21V18C1.50046 17.6023 1.65864 17.221 1.93984 16.9398C2.22105 16.6586 2.60232 16.5005 3 16.5H9C9.39768 16.5005 9.77895 16.6586 10.0602 16.9398C10.3414 17.221 10.4995 17.6023 10.5 18V21C10.4995 21.3977 10.3414 21.7789 10.0602 22.0602C9.77895 22.3414 9.39768 22.4995 9 22.5ZM3 18V21H9V18H3Z"
        fill="currentColor"
      />
    </svg>
  ),
  Trophy: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 5.25H18V4.5C17.9995 4.10232 17.8414 3.72105 17.5602 3.43984C17.279 3.15864 16.8977 3.00046 16.5 3H7.5C7.10232 3.00046 6.72105 3.15864 6.43984 3.43984C6.15864 3.72105 6.00046 4.10232 6 4.5V5.25H4.5C4.10232 5.25046 3.72105 5.40864 3.43984 5.68984C3.15864 5.97105 3.00046 6.35232 3 6.75V9C3.00089 9.79538 3.31725 10.5579 3.87967 11.1203C4.44208 11.6827 5.20462 11.9991 6 12H6.2415C6.55401 13.1481 7.19405 14.1803 8.08346 14.9706C8.97287 15.7609 10.0732 16.2752 11.25 16.4506V19.5H7.5V21H16.5V19.5H12.75V16.4483C13.9421 16.3009 15.0621 15.7976 15.9639 15.0041C16.8656 14.2106 17.5072 13.1637 17.805 12H18C18.7954 11.9991 19.5579 11.6827 20.1203 11.1203C20.6828 10.5579 20.9991 9.79538 21 9V6.75C20.9995 6.35232 20.8414 5.97105 20.5602 5.68984C20.2789 5.40864 19.8977 5.25046 19.5 5.25ZM6 10.5C5.60232 10.4995 5.22105 10.3414 4.93984 10.0602C4.65864 9.77895 4.50046 9.39768 4.5 9V6.75H6V10.5ZM16.5 10.5C16.5 11.1027 16.3789 11.6992 16.144 12.2542C15.9091 12.8091 15.5651 13.3113 15.1324 13.7308C14.6997 14.1503 14.1872 14.4786 13.6252 14.6963C13.0632 14.9139 12.4632 15.0165 11.8609 14.9978C10.6665 14.9237 9.5467 14.392 8.73445 13.5132C7.92219 12.6345 7.48004 11.4764 7.5 10.2799V4.5H16.5V10.5ZM19.5 9C19.4995 9.39768 19.3414 9.77895 19.0602 10.0602C18.779 10.3414 18.3977 10.4995 18 10.5V6.75H19.5V9Z"
        fill="currentColor"
      />
    </svg>
  ),
  ArrowBack: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z"
        fill="currentColor"
      />
    </svg>
  ),
  Search: () => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.3335 6.16658C10.3335 8.46777 8.46802 10.3333 6.16683 10.3333C3.86564 10.3333 2.00016 8.46777 2.00016 6.16658C2.00016 3.8654 3.86564 1.99992 6.16683 1.99992C8.46802 1.99992 10.3335 3.8654 10.3335 6.16658ZM9.6603 10.8386C8.68649 11.5679 7.47711 11.9999 6.16683 11.9999C2.94517 11.9999 0.333496 9.38825 0.333496 6.16658C0.333496 2.94492 2.94517 0.333252 6.16683 0.333252C9.38849 0.333252 12.0002 2.94492 12.0002 6.16658C12.0002 7.47686 11.5682 8.68624 10.8388 9.66006L13.6668 12.4881L12.4883 13.6666L9.6603 10.8386Z"
        fill="currentColor"
      />
    </svg>
  ),
  ArrowDown: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12L18.59 10.59L13 16.17V4H11V16.17L5.42 10.58L4 12L12 20L20 12Z"
        fill="currentColor"
      />
    </svg>
  ),
  ArrowUp: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 12L5.41 13.41L11 7.83V20H13V7.83L18.58 13.42L20 12L12 4L4 12Z"
        fill="currentColor"
      />
    </svg>
  ),
  MoreHoriz: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        fill="currentColor"
      />
    </svg>
  ),
  EditPen: () => (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
        fill="currentColor"
      />
    </svg>
  ),
  LapTop: () => (
    <svg
      width="22"
      height="18"
      viewBox="0 0 22 18"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 14.0039H18.5C18.8977 14.0034 19.2789 13.8452 19.5601 13.564C19.8413 13.2828 19.9995 12.9016 20 12.5039V2.00391C19.9995 1.60622 19.8414 1.22496 19.5602 0.94375C19.2789 0.662545 18.8977 0.504363 18.5 0.503906H3.5C3.1023 0.504303 2.721 0.662466 2.43978 0.943685C2.15856 1.2249 2.0004 1.6062 2 2.00391V12.5039C2.00046 12.9016 2.15864 13.2829 2.43984 13.5641C2.72105 13.8453 3.10232 14.0034 3.5 14.0039ZM3.5 12.5039V2.00391H18.5V12.5039H3.5ZM0.5 15.5039H21.5V17.0039H0.5V15.5039Z"
        fill="currentColor"
      />
    </svg>
  ),
  CheckMark: () => (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.00013 13.4768L4.52513 10.0018L3.3418 11.1768L8.00013 15.8352L18.0001 5.83516L16.8251 4.66016L8.00013 13.4768Z"
        fill="currentColor"
      />
    </svg>
  ),
  Book: () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 4H7C5.9 4 5 4.9 5 6V18C5 19.1 5.9 20 7 20H21V4ZM19 18H7V6H19V18ZM3 6H1V20C1 21.1 1.9 22 3 22H17V20H3V6ZM15 10H9V8H15V10ZM15 14H9V12H15V14Z"
        fill="currentColor"
      />
    </svg>
  ),
};

type IconProps = {
  icon: string;
  onClick?: (e: any) => void;
} & Partial<CustomIconComponentProps>;

export const IconInt = ({ icon, onClick = () => {}, ...props }: IconProps) => (
  <Icon component={Icons[icon]} onClick={onClick} {...props} />
);
